<template>
  <article class="detail-container" @click="isOpenAddress = false">
    <div class="btn-container">
      <span @click="clickCloseBtn()" class="close-btn mdi mdi-close mdi-24px"></span>
    </div>
    <div class="chat-dialog disp-scroll" v-if="selectMessage.length!==0">
      <Balloon
        v-for="(chat, index) in selectMessage" :key="index + '-chat'"
        :id="'scrollto-' + index"
        :speaker="chat.speaker"
        :name="chat.name"
        :icon="chat.icon"
        :message="chat.message"
        :time="displayDate(chat)"
        :readTime="new Date()"
        :isBot="chat.isBot"
        :email="chat.email"
        :isManager="chat.isManager"
        :files="chat.files"
        :filename="chat.filename"
        :status="chat.status"
        :companyData="companyData"
        :parameter="chat.parameter">
      </Balloon>
    </div>
  </article>
</template>

<script>
import Balloon           from '@/components/ui/Balloon'
import { mapState } from 'vuex'

export default {
  components: {
    Balloon
  },
  props: {
    selectMessage: {
      type: Array,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isOpenAddress: false
    }
  },
  computed: {
    ...mapState('directtalk', ['companyData'])
  },  
  methods: {
    loadMessage () {
      var target = document.querySelector('div.scroll-box')
      if (target.scrollTop === 0 && !this.isGetMessageMax) {
        this.isNoScroll = true
        this.$store.dispatch('directtalk/getMessage', {name: 'manager', pages: Number(this.messagePages + 1)})
      }
    },
    formatTime (createdAt) {
      return this.$moment(createdAt).format('YYYY/MM/DD H:mm:ss')
    },
    clickCloseBtn() {
      this.$emit('clickCloseBtn', false)
    },
    displayDate(chat) {
      if (!isNaN(chat.createdAt)) {
        return new Date(chat.createdAt)
      } else {
        return new Date(chat.createdAtOther)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  text-align: left;
  position: absolute;
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #fefefe;
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 8px;
  .btn-container {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 8px;
    .close-btn {
      cursor: pointer;
    }
  }
}
.chat-dialog {
  height: 95%;
  width: 100%;
  scroll-behavior: smooth;
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/articles/MessageDetail.vue